'use client';

import type { ComponentUsercentricsStoryblok } from '@/types/component-types-sb';
import dynamic from 'next/dynamic';

const UsercentricsImpl: React.FC<{ blok: ComponentUsercentricsStoryblok }> = ({ blok: _blok }) => {
  return <div className="uc-embed" uc-styling="true" uc-show-toggle="true" uc-embedding-type="category"></div>;
};

const Usercentrics = dynamic(() => Promise.resolve({ default: UsercentricsImpl }), {
  ssr: false,
});

export default Usercentrics;
